export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14188.befdd369.jpg";